var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonwhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1944 2.27015C11.5103 1.53151 10.5548 1.12476 9.50003 1.12476C8.43972 1.12476 7.48101 1.52905 6.80003 2.26311C6.11167 3.00526 5.77628 4.0139 5.85503 5.10304C6.01113 7.25179 7.64624 8.99975 9.50003 8.99975C11.3539 8.99975 12.9862 7.25214 13.1447 5.10374C13.2245 4.02444 12.887 3.01792 12.1944 2.27015Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6877 16.874H3.3127C3.15072 16.8761 2.99031 16.842 2.84314 16.7744C2.69597 16.7067 2.56574 16.607 2.46192 16.4827C2.2334 16.2095 2.14129 15.8365 2.2095 15.4593C2.50622 13.8133 3.43223 12.4306 4.8877 11.4599C6.18075 10.5982 7.81868 10.124 9.5002 10.124C11.1817 10.124 12.8196 10.5986 14.1127 11.4599C15.5682 12.4302 16.4942 13.8129 16.7909 15.4589C16.8591 15.8361 16.767 16.2092 16.5385 16.4823C16.4347 16.6067 16.3045 16.7064 16.1573 16.7742C16.0101 16.8419 15.8497 16.876 15.6877 16.874Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonwhite);
export default __webpack_public_path__ + "static/media/Personwhite.f1dfdaffe84792841dd846753aa5b9b0.svg";
export { ForwardRef as ReactComponent };